export const CV = () => <div style={{textAlign: "center"}}>
  <br/>
  <span style={{color: "gray"}}>--Last updated on 31. 5. 2024--</span><br/>
  <iframe src="Jan_Skladal_Resume_31_05_2024.pdf#toolbar=0&zoom=80" height="700vh" width="100%"/><br/>
  <a href="Jan_Skladal_Resume_31_05_2024.pdf" style={{color: "lime", textDecoration: "underline"}}>Jan_Skladal_Resume_31_05_2024.pdf</a>
</div>